module.exports = __webpack_public_path__ + "9124cc50f43cfa47dd47882e2f98db79.MP3";